import type { ComplianceWithCoursesResponseHydrated } from "src/api/compliance";
import type { UserWithRoles } from "src/shared/api-types/user";

import { CatalogRequirements, isProfileSetupIncomplete } from "../compliance/profileSetup";

export type MemberWithProfileSetup = UserWithRoles & { profileSetupIncomplete: boolean };

type ComplianceByUserId = Record<string, Pick<ComplianceWithCoursesResponseHydrated, "relationTree">>;

/**
 * Enrich member rows with a `profileSetupIncomplete` flag derived from the batch
 * compliance response (userId -> relationTree). With crew catalog requirements
 * the flag is per-role (any role requiring properties without them — CREW-530);
 * without them (null/undefined) it falls back to the legacy all-roles-empty
 * heuristic. A member absent from the batch — or one whose relation tree can't
 * be read — is treated as complete (not flagged), so a missing/failed
 * compliance or catalog load never mislabels the list.
 */
export const withProfileSetupFlag = (
  members: UserWithRoles[],
  complianceByUserId?: ComplianceByUserId | null,
  catalogRequirements?: CatalogRequirements | null,
): MemberWithProfileSetup[] =>
  members.map((member) => ({
    ...member,
    profileSetupIncomplete: isProfileSetupIncomplete(
      complianceByUserId?.[String(member.id)]?.relationTree,
      catalogRequirements ?? null,
    ),
  }));
